import { Link2 } from 'lucide-react';

import type { UserRow } from '../userViewModel';

import UserAvatar from './UserAvatar';

interface ImportedNameMatchesProps {
  candidates: UserRow[];
  onPick: (user: UserRow) => void;
}

/**
 * The list of imported people whose name matches the one being typed, offered
 * so the operator can link one instead of creating a duplicate.
 */
export default function ImportedNameMatches({ candidates, onPick }: ImportedNameMatchesProps) {
  if (candidates.length === 0) return null;
  return (
    <div className="p-3 rounded-lg border border-[#FAC775] bg-[#FAECD8] dark:border-[#7A5A22] dark:bg-[#33260F]">
      <div className="text-[9.5px] font-bold tracking-wider uppercase text-[#BA7517] dark:text-[#F0C97D] mb-1">
        Is this one of these imported people?
      </div>
      <div className="text-[11px] text-bark-800 dark:text-[#e8ece9] mb-2 leading-snug">
        These FareHarbor staff records match the name and have no login yet. Pick one to invite them
        without creating a duplicate.
      </div>
      <ul className="m-0 p-0 list-none flex flex-col gap-1">
        {candidates.map((u) => (
          <li key={u.id}>
            <button
              type="button"
              onClick={() => onPick(u)}
              className="w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-md text-left bg-white dark:bg-[#1a1f1c] border border-transparent hover:border-[#BA7517] dark:hover:border-[#F0C97D]"
            >
              <UserAvatar name={u.name} size={24} />
              <span className="flex-1 min-w-0">
                <span className="block text-[12.5px] font-semibold text-bark-900 dark:text-[#e8ece9] truncate">
                  {u.name}
                </span>
                <span className="block text-[10.5px] text-stone-500 dark:text-stone-400 font-mono">
                  {u.fareharborUsername ?? 'no FareHarbor username'} · {u.upcomingWorkshops}{' '}
                  upcoming
                </span>
              </span>
              <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#BA7517] dark:text-[#F0C97D]">
                <Link2 size={12} />
                Link
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
